import { API_PART_URL } from "src/shared/config/src";
import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";

export const fetchEyengagePostsApi = async ({ child, ...queryParams }: { child: ChildrenStoreData, page: number, categories?: string, type?: string }): Promise<any> => {
    console.log("fetching eyengage posts :", child.childId);
    let queryObj: any = { ...queryParams };
    if (!queryObj || !(Object.keys(queryObj).length > 0)) {
        queryObj = { page: 1 };
    }
    // console.log("Query obj : ", queryObj);
    // let queryObj: any = { page };
    // if (filterObj && Object.keys(filterObj).length > 0) {
    //     queryObj = { ...queryObj, ...filterObj };
    // }
    // console.log("Query obj : ", queryObj);
    const { retryAxios } = getAxiosInstance();
    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/nursery/${child.nursery.eymanNurseryId}/posts?${new URLSearchParams(queryObj).toString()}`).then((res) => {
        // console.log("response from eyengage  call : ", JSON.stringify(res.data, null, 2));
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const fetchEyengagePostDetails = async ({ child, postId }: { child: ChildrenStoreData, postId: string }): Promise<any> => {
    console.log("fetching postdetails for :", child.childId, postId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/nursery/${child.nursery.eymanNurseryId}/post/${postId}`).then((res) => {
        console.log("response from postdetails  call : ", res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const fetchPostReactionsList = async ({ child, postId }: { child: ChildrenStoreData, postId: string }): Promise<any> => {
    console.log("fetching reaction list for :", child.childId, postId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/nursery/${child.nursery.eymanNurseryId}/post/${postId}/reactions`).then((res) => {
        console.log("response from get likes on post  call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const patchLikeOnPost = async ({ child, postId }: { child: ChildrenStoreData, postId: string }): Promise<any> => {
    console.log("patching like on post for :", child.childId, postId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.patch(`${child.instanceUrl}${API_PART_URL}/nursery/${child.nursery.eymanNurseryId}/post/${postId}/reaction`, { type: 'like' }).then((res) => {
        console.log("response from patch like on post  call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const addCommentOnPost = async ({ child, postId, commentText }: { child: ChildrenStoreData, postId: string, commentText: string }): Promise<any> => {
    console.log("adding a comment on observation for :", child.childId, postId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.patch(`${child.instanceUrl}${API_PART_URL}/nursery/${child.nursery.eymanNurseryId}/post/${postId}/comment`, { comment: commentText }).then((res) => {
        console.log("response from add comment on post  call : ", res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const deleteCommentOnPost = async ({ child, postId, commentId }: { child: ChildrenStoreData, postId: string, commentId: string }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;
    return retryAxios.delete(`${child.instanceUrl}${API_PART_URL}/nursery/${child.nursery.eymanNurseryId}/post/${postId}/comment/${commentId}`).then((res) => {
        console.log("response from delete comments on eyengage call : ", res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const patchPostConfirmation = async ({ child, postId }: { child: ChildrenStoreData, postId: string }): Promise<any> => {
    console.log("patching patchPostConfirmation :", child.childId, postId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.patch(`${child.instanceUrl}${API_PART_URL}/nursery/${child.nursery.eymanNurseryId}/post/${postId}/confirm`).then((res) => {
        console.log("response patchPostConfirmation : ", res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const patchEyengagePollSelection = async ({ child, postId, selectedOptions }: { child: ChildrenStoreData, postId: string, selectedOptions: string[] }): Promise<any> => {
    console.log("patching patchEyengagePollSelection :", child.childId, postId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.patch(`${child.instanceUrl}${API_PART_URL}/nursery/${child.nursery.eymanNurseryId}/post/${postId}/poll-response`, { optionIds: selectedOptions }).then((res) => {
        console.log("response patchEyengagePollSelection : ", res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const fetchEymanageSettings = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    console.log("fetching reaction list for :", child.childId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/nursery/${child.nursery.eymanNurseryId}/settings`).then((res) => {
        // console.log("response from eyman settings  call : ", JSON.stringify(res.data, null, 2));
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}